import React, { FC, ChangeEvent, Fragment, useMemo, memo } from 'react';
import '../../styles/PitBimWinRange.scss';
interface PitBimWinRangeProps {
  value: string;
  step?: number;
  min?: number;
  max?: number;
  isShowTip?: boolean;
  onChange?(e: ChangeEvent<HTMLInputElement>): void;
}
const PitBimWinRange: FC<PitBimWinRangeProps> = memo(
  ({ value, step, min, max, isShowTip, onChange }) => {
    const speedStyleObject = useMemo(() => {
      let count = (Number(value) / (max || 16)) * 100;
      return {
        background: `linear-gradient(to right, #57f3ff 0%, #46d0e0 ${count -
          3}%, rgb(153, 153, 153) ${count - 3}%, rgb(153, 153, 153) 100%)`,
      };
    }, [value, max]);
    return (
      <div className="pit-bim-win-range">
        <input
          type="range"
          step={step}
          min={min}
          max={max}
          value={value}
          onChange={e => onChange && onChange(e)}
          style={speedStyleObject}
        />
        {isShowTip ? (
          <Fragment>
            <span className="pit-range-min">1</span>
            <span className="pit-range-cur">{{ value }}</span>
            <span className="pit-range-max">16</span>
            <span className="pit-range-progress"></span>
          </Fragment>
        ) : (
          ''
        )}
      </div>
    );
  }
);
PitBimWinRange.defaultProps = {
  max: 16,
  min: 1,
  step: 1,
  isShowTip: false,
};
export default PitBimWinRange;
